export function formatDate(date) {
    const data = date.split('-')
    return data[2].split(' ')[0] + ' ' + getMonth(data[1]) + ' ' + data[0]
  }
  
  function getMonth(month) {
    return {
      '01': 'Ene',
      '02': 'Feb',
      '03': 'Mar',
      '04': 'Abr',
      '05': 'Mayo',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Ago',
      '09': 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dic',
    }[month]
  }